import React from 'react';
import { FD140 } from '../../../services/d204Api';
import { fmt } from '../helpers';

interface Tab2Props {
  formData: Partial<FD140>;
  isEditing: boolean;
  isFieldDisabled: (key: string) => boolean;
  getField: (key: keyof FD140) => FD140[keyof FD140];
  setField: (key: keyof FD140, value: FD140[keyof FD140]) => void;
}

const Tab2Product: React.FC<Tab2Props> = React.memo(({
  formData, isEditing, isFieldDisabled,
  getField, setField,
}) => {
  return (
    <div className="form-section odd">
      <span className="section-tag">產品說明</span>
      <div className="form-grid">
        <label>產品代號(前段)</label>
        <input type="text" style={{ maxWidth: 120 }}
          disabled={isFieldDisabled('fd140_181')}
          value={getField('fd140_181') as string}
          onChange={e => setField('fd140_181', e.target.value)} data-contract-field="fd140_181"
        />

        <label>產品代號(後段)</label>
        <input type="text" style={{ maxWidth: 120 }}
          disabled={isFieldDisabled('fd140_182')}
          value={getField('fd140_182') as string}
          onChange={e => setField('fd140_182', e.target.value)} data-contract-field="fd140_182"
        />

        <label>產品名稱</label>
        <textarea style={{ maxWidth: 320, minHeight: 60 }}
          disabled={isFieldDisabled('fd140_51')}
          value={getField('fd140_51') as string}
          onChange={e => setField('fd140_51', e.target.value)} data-contract-field="fd140_51"
        />

        <label>產品規格</label>
        <textarea style={{ maxWidth: 320, minHeight: 60 }}
          disabled={isFieldDisabled('fd140_52')}
          value={getField('fd140_52') as string}
          onChange={e => setField('fd140_52', e.target.value)} data-contract-field="fd140_52"
        />

        <label>加工別</label>
        <textarea style={{ maxWidth: 200, minHeight: 40 }}
          disabled={isFieldDisabled('fd140_53')}
          value={getField('fd140_53') as string}
          onChange={e => setField('fd140_53', e.target.value)} data-contract-field="fd140_53"
        />

        <label>幅寬(針孔內)</label>
        <input type="number" style={{ maxWidth: 100 }} step="0.1"
          disabled={isFieldDisabled('fd140_54')}
          value={getField('fd140_54') as number || ''}
          onChange={e => setField('fd140_54', parseFloat(e.target.value) || 0)} data-contract-field="fd140_54"
        />

        <label>幅寬(針孔外)</label>
        <input type="number" style={{ maxWidth: 100 }} step="0.1"
          disabled={isFieldDisabled('fd140_55')}
          value={getField('fd140_55') as number || ''}
          onChange={e => setField('fd140_55', parseFloat(e.target.value) || 0)} data-contract-field="fd140_55"
        />

        <label>碼重</label>
        <input type="number" style={{ maxWidth: 100 }} step="0.1"
          disabled={isFieldDisabled('fd140_56')}
          value={getField('fd140_56') as number || ''}
          onChange={e => setField('fd140_56', parseFloat(e.target.value) || 0)} data-contract-field="fd140_56"
        />

        <label>米平方重</label>
        <input type="number" style={{ maxWidth: 100 }} step="0.1"
          disabled={isFieldDisabled('fd140_57')}
          value={getField('fd140_57') as number || ''}
          onChange={e => setField('fd140_57', parseFloat(e.target.value) || 0)} data-contract-field="fd140_57"
        />

        <label>平均單價</label>
        <input type="text" readOnly style={{ maxWidth: 120, textAlign: 'right' }}
          value={fmt(formData.fd140_19)} data-contract-field="fd140_19"
        />

        <label>本次投入量</label>
        <input type="number" style={{ maxWidth: 120 }} step="0.01"
          disabled={isFieldDisabled('fd140_20')}
          value={getField('fd140_20') as number || ''}
          onChange={e => setField('fd140_20', parseFloat(e.target.value) || 0)} data-contract-field="fd140_20"
        />

        <label>總入庫量</label>
        <input type="text" readOnly style={{ maxWidth: 120, textAlign: 'right' }}
          value={fmt(formData.fd140_21)} data-contract-field="fd140_21"
        />

        <label>樣品數量</label>
        <input type="number" style={{ maxWidth: 100 }} step="0.01"
          disabled={isFieldDisabled('fd140_22')}
          value={getField('fd140_22') as number || ''}
          onChange={e => setField('fd140_22', parseFloat(e.target.value) || 0)} data-contract-field="fd140_22"
        />
      </div>
    </div>
  );
});

Tab2Product.displayName = 'Tab2Product';
export default Tab2Product;
